export const messages = Object.freeze({
    afs_not_mounted_in_any_space: 'This file share is not mounted in a space. Mount it in a space before performing this action.',
    archive_snapshot_failure: 'The archive snapshot operation failed. Please try again or contact support.',
    auto_snapshot_not_latest: 'This automatic snapshot is no longer the latest one. Refresh the snapshot list and select the latest snapshot.',
    backup_missing_filesystem_prefix: 'The backup location could not be determined. Please contact support.',
    backup_tree_hash_mismatch: 'The backup could not be verified. Please contact support.',
    db_rpid_mismatched: 'The resource pool information is inconsistent. Please contact support.',
    distributed_dev_missing: 'The distributed dev is missing or could not be found.',
    distributed_missing: 'The distributed is missing or could not be found.',
    empty_csv_data: 'Please provide valid CSV data with instance names and email addresses.',
    empty_instance_name: 'Instance name is required for each line.',
    hpc_not_enabled: 'Hpc is not enabled. Please check your selection and try again.',
    illegal_area: 'Invalid area. Please check your input.',
    illegal_pool_name: 'Invalid pool name. Please check your input.',
    illegal_special_file_type: 'Invalid special file type. Please check your input.',
    invalid_csv_format: 'Each line must have at least an instance name and one email address, separated by commas.',
    invalid_init_type: 'Invalid init type. Please check your input and try again.',
    invalid_input_quota: 'Invalid input quota. Please check your input and try again.',
    invalid_migration_mode: 'Invalid migration mode. Please check your input and try again.',
    invalid_resting_policy: 'Invalid resting policy. Please check your input and try again.',
    invalid_resting_threshold: 'Invalid resting threshold. Please check your input and try again.',
    invalid_source_region: 'Invalid source region. Please check your input and try again.',
    invalid_target_region: 'Invalid target region. Please check your input and try again.',
    missing_quota_value: 'Required quota value is missing.',
    missing_source_region: 'Required source region is missing.',
    missing_target_region: 'Required target region is missing.',
    missing_task_or_space: 'Required task or space is missing.',
    name_already_taken: 'This name already is already taken. Please choose another one.',
    no_emails: 'At least one email address is required for each instance.',
    no_immutable_snapshots: 'No immutable snapshots was found or provided.',
    no_instance_role_found: 'No instance role was found.',
    No_role_found: 'No role was found. Please check your selection and try again.',
    permission_denied: "You don't have permission to perform this action.",
    quota_exceeds_rp_max_quota: 'The requested quota exceeds the resource pool maximum.',
    role_check_failed: "You don't have permission to perform this action.",
    same_region: 'The space is already in this region.',
    sid_is_none: 'A required space value is missing from the request.',
    sids_required: 'Spaces is required. Please check your selection and try again.',
    space_credit_limit_end_date_change_non_monotonic: "The credit limit end date can't be moved earlier.",
    space_credit_limit_past: 'The credit limit dates must be in the future.',
    space_deleted: 'The space has been deleted.',
    space_not_archived: 'The space not has been archived.',
    space_not_teaching_space: 'The space is not teaching space.',
    tables_not_enabled: 'Tables is not enabled.',
    unidentifiable_afs_mount_request: 'The file share mount could not be identified. Refresh the page and try again.',
    unidentifiable_afs_request: 'The file share could not be identified. Refresh the page and try again.',
    unidentifiable_token_request: 'The request could not be processed because a required identifier is missing.',
    unknown_space_type: 'Unknown space type. Please check your selection and try again.',
    unsupported_region: 'Unsupported region. Please check your selection and try again.'
})

export const dialogs = Object.freeze({
    vimeo_not_enabled_org: {
        dialogTitle: 'Video library not enabled!',
        dialogText: 'Video library upload is not enabled for your organization, please ask us to enable it for you.',
        dialogAction: ['dismiss']
    },
    vimeo_not_enabled_space: {
        dialogTitle: 'Video library not enabled!',
        dialogText: 'Video library upload is not enabled in your space. Please go to space configuration and enable video library upload.',
        dialogAction: ['dismiss']
    },
    instance_limit_reached: {
        dialogTitle: "Can't create new instance!",
        dialogText: 'The instance limit has been reached. Remove an unused instance or contact your administrator.',
        dialogAction: ['close']
    }
})
